module.exports = __webpack_public_path__ + "img/shopping-bag-2-line.510ddd1e.svg";